<!--  開刀房用 -->

<template lang="pug">
div.with-child-centered(style="height: 100%")
  Loader(v-if="getScheduled === false")
  div.schedules-wrapper(v-if="scheduleByPatient.length > 0 && getScheduled")
    div.with-child-centered(v-if="false")
      h4 今日無病人須於此藥櫃操作
    SplitLayout(v-else style="padding-top: 10px")
      div(slot="left")
        h5.text-center 1.選擇病人
        div(style="height: 418px; overflow-y: auto")
          div(v-for="patient, ind in scheduleByPatient"
          :style="{ display: 'inline-block', width: '98%', backgroundColor: colormaps[(ind % colormaps.length)], color: 'white', border: '1px solid transparent' }"
          :class="{'surgery-item': true, 'sch-selected': ind === patientSelected }"
          @click="patientSelectFun(ind)" )
            p 
              span(style="padding-right: 1rem")
                font-awesome-icon(:icon="faUser" color="white")
              strong
                span {{ patient.patient.med_record_number }} 
                span {{ patient.patient.name }} 
                span(v-if="patient.patient.gender") ( {{patient.patient.gender| genderZh }} )
              span.float-right
                span {{ $store.state.device.systemArea | areaFormat }}
                //span {{patient.bed.ward.name}}
                span {{patient.bed.code}}
                
      div(slot="right")
        h5.text-center 2.手術相關資訊
        div(style="height: 418px; overflow-y: auto")
          div(v-if="patientSelected !== undefined")
            div(v-for="schedule, ind in scheduleByPatient[patientSelected].schedules"
              :style="{ display: 'inline-block', width: '98%'}"
              :class="{'surgery-item': true}"
              @click="selecteSchedule(schedule.id)"
            )
              p 
                span(style="padding-right: 1rem")
                  font-awesome-icon(:icon="faUserMd" color="black", style="font-size:32px")
                p(v-if="schedule.extra_info" v-html="extraInfoZh(JSON.parse(schedule.extra_info))") 
          div.with-child-centered(v-else)
            p 請先選擇病人
  div.with-child-centered(v-if="scheduleByPatient.length === 0 && getScheduled"
                          @click="manualSchedule")
    h4 無排程資料
</template>


<script>
import moment from 'moment';
import _ from 'lodash';
import { faUser, faUserMd } from '@fortawesome/free-solid-svg-icons';
import Loader from '../common/Loader';
import SplitLayout from '../SplitLayout';


export default {
  name: 'OperatingRoomScheduleList',
  props: {
  },
  data() {
    return {
      getScheduled: false,
      scheduleToday: undefined,
      beds: undefined,
      scheduleByPatient: [],
      patientSelected: undefined,
      colormaps: [
        '#3BB143',
      ],
      faUser,
      faUserMd,
    };
  },
  components: {
    Loader,
    SplitLayout,
  },
  async mounted() {
    this.initSchedules();
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    //get schedule
    async initSchedules() {
      this.getScheduled = false;
      // reset variables
      this.$store.commit('RESET_SCHEDULE');
      this.scheduleToday = {};
      this.scheduleByPatient = [];
      //擷取沒有hidden的schedule
      //await this.$store.dispatch('getSchedule');
      await this.$store.dispatch('getOperatingRoomSchedule');

      this.filterScheduleToday();
      this.definePatientAndSchedule();
      this.getScheduled = true;
    },
    filterScheduleToday() {
      //與排班有關,目前沒有用到
      /*
      if (this.$store.state.generalSetting.shift_system_status) {
        const userId = this.$store.state.user.user.id;
        const filterdSchedule = [];
        Object.values(this.$store.getters.scheduleToday).forEach((sch) => {
          for (let i = 0; i < sch.shift.length; i += 1) {
            const sh = sch.shift[i];
            if (sh.employee === userId) {
              filterdSchedule.push(sch);
              break;
            }
          }
        });
        this.scheduleToday = filterdSchedule;
      } else {
        this.scheduleToday = this.$store.getters.scheduleToday;
      }
      */
      this.scheduleToday = this.$store.getters.scheduleToday;
    },
    definePatientAndSchedule() {
      const patients = {};
      Object.values(this.scheduleToday).forEach((sch) => {
        const patientId = sch.patient.id;
        if (patients[patientId] === undefined) {
          patients[patientId] = {};
          patients[patientId].patient = sch.patient;
          patients[patientId].schedules = [];
          patients[patientId].bed = sch.bed;
        }
        patients[patientId].schedules.push(sch);
      });

      this.scheduleByPatient = _.sortBy(Object.values(patients), ['bed.ward.name', 'bed.code']);
    },
    selecteSchedule(id) {
      this.$store.commit('SET_CURRENT_SCHEDULE_BY_ID', id);
      this.$emit('setSchedule');
    },
    extraInfoZh(val) {
      let context = '';
      if (val.diagnosis_name) { context += `<strong><p>診斷名稱: ${val.diagnosis_name}</p></strong>`; }
      if (val.surgery_time) { context += `<strong><p>手術日期: ${val.surgery_time}</p></strong>`; }
      if (val.surgery_name) { context += `<strong><p>手術名稱: ${val.surgery_name}</p></strong>`; }
      if (val.surgery_room) { context += `<strong><p>手術房間: ${val.surgery_room}</p></strong>`; }
      return context;
    },
    patientSelectFun(val) {
      if(this.patientSelected==val) {
        this.patientSelected = undefined;
        this.$emit('setPatientSchedule', {
          medRecordId: "",
          manualEnable: true,
          bedId: undefined,
          gender: undefined,
        });
      }
      else {
        this.patientSelected = val;
        this.$emit('setPatientSchedule', {
          medRecordId: this.scheduleByPatient[val].patient.med_record_number,
          manualEnable: false,
          bedId: this.scheduleByPatient[val].bed.id,
          gender: this.scheduleByPatient[val].patient.gender,
        });
      }
    },
  },
  filters: {
    genderZh(val) {
      if (val === 'male') return '男';
      if (val === 'female') return '女';
      return '';
    },
    areaFormat(obj) {
      return obj.department.name + obj.name;
    },
  },
  watch: {
  },
};
</script>


<style lang="sass" scoped>
.surgery-list
  overflow-y: auto
  width: 100%
  height: 412px
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 6px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;

.surgery-item
  width: 225px 
  padding: 5px 10px
  margin: 2px
  box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  // border-radius: 5px
  display: inline-flex
  border: 2px solid transparent
  max-height: 200px
  background-color: #ffbf00;
  p, hr
    margin: 0
  .surgery-item-right
    font-size: 54px;
    width: 35%
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    img
      width: 50px
      height: 50px
  .surgery-item-left
    width: 65%
    padding: 3px
    display: flex
    flex-direction: column
    #emr
      padding-left: 10px
      color: rgba(0,0,0,0.4)
    #med, #bed, #time, #ward
      font-size: 0.8rem
.selected
  border-color: red

.item-center
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center

.fetched-schedule
  color: rgba(0,0,0,0.2)


.surgery-by-bed-list
  width: 100%
  height: 412px
  overflow-x: hidden
  overflow-y: scroll
  // white-space: nowrap

.bed-code
  background: cadetblue
  color: white
  border-top-left-radius: 5px
  border-top-right-radius: 5px

.schedule-by-ward
  display: inline-flex
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 49%
  margin: 2px
  height: 42px
  box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  // border-radius: 5px
  background: cadetblue;
  color: white;
  &.selected
    background-color: #FF3811

  // p
  //   margin: 0px
  //   background: cadetblue
  //   color: white
  //   border-top-left-radius: 5px
  //   border-top-right-radius: 5px
  // .schedule-item
  //   .patient-info
  //     margin: 12px 0px
  //   hr
  //     margin: 0px

      

.schedules-wrapper
  height: 100%; 
  width: 100%;


.sch-selected
  border: 2px solid red !important

</style>



// WEBPACK FOOTER //
// OperatingRoomScheduleList.vue?5ab6cd7f